import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateUpdateClub = {
  updateClub: { data: null, loading: false, error: null },
};

export const updateClub = createAsyncThunk('user/updateClub', async ({ clubId, ...data }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/club/update/${clubId}`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUpdateClub = {
  [updateClub.pending]: (state) => {
    state.updateClub.loading = true;
  },
  [updateClub.fulfilled]: (state, action) => {
    state.updateClub.loading = false;
    state.updateClub.data = action.payload;
    state.updateClub.error = null;
  },
  [updateClub.rejected]: (state, action) => {
    state.updateClub.data = null;
    state.updateClub.loading = false;
    state.updateClub.error = action.payload;
  },
};
